import preactLogo from '../../assets/preact.svg';
import './style.css';

import { Table } from '../../components/Table';
import { CommitColumn } from '../../components/CommitColumn';

export function Home() {
	return (
		<div class="home">
			<h1><a href="https://ci.chromium.org/p/chromium/g/main/console">luci me not</a></h1>
			<section>
				<Table></Table>
			</section>
		</div>
	);
}

function Resource(props) {
	return (
		<a href={props.href} target="_blank" class="resource">
			<h2>{props.title}</h2>
			<p>{props.description}</p>
		</a>
	);
}
